import styled from "styled-components";
import logoImg from "../../Assets/logo.png";
import userImg from "../../Assets/user-avatar.jpg";

export const NavContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 3rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Logo = styled.img`
  background-image: url(${logoImg});
  width: 20%;
  height: 10vh;
  background-size: contain;
  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    width: 50%;
  }
`;

export const SearchContainer = styled.form`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;

  input {
    width: 300px;
    height: 40px;
    border: 2px solid #3cc830;
    border-radius: 5px;
    padding: 1rem 2rem;
    outline: none;
    font-size: 1.6rem;
  }

  @media screen and (max-width: 768px) {
  }
`;

export const WishListContainer = styled.div`
  a {
    text-decoration: none;
    font-weight: bold;
    font-size: 1.6rem;
    color: #3cc830;
  }

  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    align-self: flex-start;
    margin-l
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0 1rem;

  a {
    text-decoration: none;
    font-weight: bold;
    font-size: 1.6rem;
    color: #3cc830;
  }

  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    align-self: flex-start;
  }
`;

export const Img = styled.img`
  background-image: url(${userImg});
  height: 40px;
  width: 40px;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
`;
